// extracted by mini-css-extract-plugin
export default {"container":"AtPM_d","isRightAlignment":"ct3yf1"};